import { render, staticRenderFns } from "./trackDetail.vue?vue&type=template&id=5065fc70"
import script from "./trackDetail.vue?vue&type=script&lang=js"
export * from "./trackDetail.vue?vue&type=script&lang=js"
import style0 from "./trackDetail.vue?vue&type=style&index=0&id=5065fc70&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5065fc70')) {
      api.createRecord('5065fc70', component.options)
    } else {
      api.reload('5065fc70', component.options)
    }
    module.hot.accept("./trackDetail.vue?vue&type=template&id=5065fc70", function () {
      api.rerender('5065fc70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Order/cmp/trackDetail.vue"
export default component.exports